/** Maps design-system Button variants to global CSS classes in index.css. */
export const BUTTON_VARIANT_CLASS = {
  primary: 'primary',
  secondary: 'secondary',
  ghost: 'ghost',
  link: 'link-cta',
  icon: 'btn-icon',
  danger: 'danger',
  destructive: 'destructive-text',
  accent: 'accent',
}
